export default __webpack_public_path__ + "static/media/cycling-bg.b7df4727.png";